import Typed from "typed.js";
import "./index.scss";
import React, { useState, useEffect } from "react";
import supplierMobile from "../../assets/supplier-mobile.png";
import card from "../../assets/card.png";

const SupplierFirstSection = ({ data }) => {
  const { title, mainImage } = data;
  const el = React.useRef(null);
  // let title = "title";
  React.useEffect(() => {
    const typed = new Typed(el.current, {
      strings: [
        "B2B Payments",
        "Credit limit",
        "Invoicing",
        "Transparent",
        "Digital",
        "Instant",
      ],
      typeSpeed: 100,
      loop: true,
    });

    return () => {
      // Destroy Typed instance during cleanup to stop animation
      typed.destroy();
    };
  }, []);
  return (
    <div
      className="supplier-first-section-container"
      style={
        {
          // backgroundColor: backgroundColor,
        }
      }
    >
      <div className="supplier-first-section">
        <div className="supplier-first-section-row">
          <div className="supplier-first-section-right">
            <div className="supplier-first-section-right-row">
              <img src={supplierMobile} />
              <img src={card} />
            </div>
          </div>
          <img
            className="supplier-first-section-image"
            alt={title}
            src={mainImage}
          />
        </div>
      </div>
      <div className="supplier-first-section-background">
        <p className="supplier-first-section-subtitle title">
          Stryve is :
          <span className="text-slider-items" ref={el} />
        </p>
        <p className="supplier-first-section-subtitle title2">
          B2B Payments Re-Imagined
        </p>
      </div>
    </div>
  );
};

export default SupplierFirstSection;
